"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Editor = void 0;
const react_1 = __importDefault(require("react"));
const lodash_1 = require("lodash");
const react_2 = __importDefault(require("@monaco-editor/react"));
const event_callback_hook_1 = require("../../utils/event-callback-hook");
function Editor({ value, onChange = lodash_1.noop, height = 200, language, disabled, }) {
    // fix undefined value
    value = value !== null && value !== void 0 ? value : null;
    // prepare value for MUI component
    value = value !== null && value !== void 0 ? value : '';
    language = language !== null && language !== void 0 ? language : 'text';
    const handleChange = event_callback_hook_1.useEventCallback((value) => {
        onChange(value !== null && value !== void 0 ? value : null);
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_2.default, { height: height, language: language, value: value, theme: "vs-light", options: {
                selectOnLineNumbers: true,
                readOnly: disabled,
                automaticLayout: true,
                minimap: {
                    enabled: false,
                },
                wordWrap: 'on',
                wrappingIndent: 'indent',
                folding: true,
            }, onChange: handleChange })));
}
exports.Editor = Editor;
//# sourceMappingURL=editor.js.map